export type RegisterItemInspectionSchedulingType = 'ONCE' | 'RECURRING'

export type ScheduleConfigPayloadType = {
  type: RegisterItemInspectionSchedulingType
  frequencyInDays: number | null
  excludeWeekends: boolean
  isActive: boolean
  checklistTemplateId: number | null
}

export type ScheduledInspectionCreatePayloadType = {
  registerTemplateInspectionId: string
  nextInspectionDue: string | null
  scheduleConfig: ScheduleConfigPayloadType
  assignedTo: number
}

export type ScheduledInspectionUpdatePayloadType = {
  nextInspectionDue: string | null
  scheduleConfig: ScheduleConfigPayloadType
  assignedTo: number
}

export type ScheduleInspectionFrequencyType =
  | 'ONCE'
  | 'DAILY'
  | 'WEEKLY'
  | 'MONTHLY'
  | 'CUSTOM'

export const SCHEDULE_INSPECTION_FREQUENCY_VALUES: ScheduleInspectionFrequencyType[] =
  ['ONCE', 'DAILY', 'WEEKLY', 'MONTHLY', 'CUSTOM']

export type ScheduleInspectionFormValuesType = {
  inspectionId: number | undefined
  frequency: ScheduleInspectionFrequencyType
  dueDate: string | null
  firstDueDate: string | null
  customIntervalDays: number
  excludeWeekends: boolean
  assigneeUserId: number | undefined
}

export type ScheduledInspectionLevel = 'REGISTER' | 'PROJECT'

export type ScheduledInspectionPermittedAction = 'READ' | 'EDIT' | 'RUN'

export type ScheduledInspectionSortKey =
  | 'dueDate'
  | 'inspectionType'
  | 'assignee'

export type ScheduledInspectionSort = `${ScheduledInspectionSortKey},${
  | 'asc'
  | 'desc'}`
